import { default as auth } from "./authReducer";
import { default as products } from "./productReducer";
import { default as selectedProduct } from "./selectedProdReducer";
import { default as orders } from "./orderReducer";
import { default as support } from "./supportReducer";
import { default as leader } from "./leaderReducer";
import { default as configReducer } from "./configReducer";
import { default as cart } from "./cartReducer";
import { default as share } from "./shareReducer";
import { default as categories } from "./categoriesReducer";
import { default as snackbar } from "./snackbarReducer";
import { default as misc } from "./miscReducer";
import { default as navigationReducer } from "./nav.reducer";
import { default as wallet } from "./oldWalletReducer";
import { default as home } from "./homeReducer";
import { default as customer } from "./customerReducer";
import { default as qtySelection } from "./qtySelectReducer";
import { default as payModal } from "./payNowModalReducer";
import { default as lgl } from "./lglReducer";
import { default as nudge } from "./nudgeReducer";
import { default as ccfp } from "./ccfpReducer";
import { default as delayedDataReducer } from "./delayDataReducer";
import { default as refresh } from "./refreshReducer";
import { default as returnOrders } from "./returnOrdersReducer";
import { default as shop } from "./shopReducer";
import { default as myDeliveries } from "./myDeliveries";
import { default as rrd } from "./rrdReducer";
import { default as shopPerformance } from "./shopPerformanceReducer";
import { default as homePageWidget } from "./homeWidgetReducer";
import { default as myTaskReducer } from "./myTaskReducer";
import deepLinkReducer from "./deepLinkReducer";

import { default as clTask } from "./clTaskReducer";
import walletReducer from "./walletReducer";
import walletV3Reducer from "./walletV3Reducer";
import returnsReducer from "./returnsReducer";
import cpDeliveryRoutesReducer from "./cpDeliveryRoutesReducer";
import location from "./locationReducer";

export default {
  auth,
  products,
  selectedProduct,
  orders,
  support,
  leader,
  configReducer,
  cart,
  share,
  categories,
  snackbar,
  misc,
  navigation: navigationReducer,
  deepLink: deepLinkReducer,
  wallet,
  home,
  customer,
  qtySelection,
  payModal,
  lgl,
  nudge,
  ccfp,
  delayedDataReducer,
  refresh,
  returnOrders,
  shop,
  shopPerformance,
  clTask,
  myDeliveries,
  rrd,
  homePageWidget,
  walletReducer,
  walletV3Reducer,
  returns: returnsReducer,
  myTaskReducer,
  cpDeliveryRoutesReducer,
  // Intentionally absent from persistConfig.whitelist in store/index.js —
  // session-scoped by design. Do not add it there.
  location,
};
